import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  props: ["headers", "items", "noDataText", "featureGroups", "global"],
  data: () => ({
    page: 1,
    itemsPerPage: 10,
    filter: {
      s: ""
    }
  }),
  methods: {
    async nextPage() {
      const pages = Math.ceil(this.items.length / this.itemsPerPage);
      if (this.page < pages) {
        this.page++;
      }
    },
    async previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    getFeatureGroupById(id) {
      let item = {};
      this.featureGroups.forEach(data => {
        if (data.id === id) {
          item = data;
        }
      });
      return item;
    },
    getFeatureGroupTitle(id) {
      return this.getFeatureGroupById(id)?.title ?? "-";
    },
    async updateSort(direction, item) {
      if (direction === "up") {
        if (item.sort > 0) item.sort -= 1;
      } else item.sort += 1;
      await this.updateFeature(item);
    },
    async updateFeature(feature) {
      const headers = await getTokenHeader();
      try {
        const response = await axios.put(
          `${env.news_api_client_url}feature`,
          feature,
          { headers }
        );
        if (response.status !== 200) await this.$store.dispatch("createError");
        else
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich aktualisiert"
          );
        await this.$store.dispatch("getFeatures", {
          principal_id: this.currentPrincipal
        });
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    }
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    }
  }
};
